<template>
  <div class="wrapper-top-ranking mb-3">
    <div
      class="card-top-ranking"
      v-for="(item, index) in top3Visual"
      :key="index"
      :style="{
        paddingBottom: item.lugar === 1 ? '60px' : '',
        border: item.lugar === 1 ? 'border: 2px solid #730ca963' : '',
      }"
    >
      <div class="top-ranking">
        <p class="m-0">
          {{ item.lugar === 1 ? "1" : item.lugar === 2 ? "2" : "3" }}
        </p>
      </div>
      <div class="mb-1">
        <img
          v-show="item.lugar === 2"
          src="../../assets/icons/trofeu-ranking.svg"
          width="26"
        />
        <img
          v-show="item.lugar === 1"
          src="../../assets/icons/crown-ranking.svg"
          width="26"
        />
        <img
          v-show="item.lugar === 3"
          src="../../assets/icons/medal-ranking.svg"
          width="26"
        />
      </div>
      <div
        class="position-relative align-self-center d-flex align-items-center align-self-center"
      >
        <object width="42" height="42" :data="item.avatar" type="image/png">
          <img
            width="42"
            height="42"
            src="../../assets/images/default.png"
            alt="Avatar hacker"
          />
        </object>

        <div v-if="item.verified" class="verify">
          <img
            src="../../assets/icons/badge-check.png"
            width="16"
            height="16"
          />
        </div>
      </div>
      <p class="top-ranking-username">{{ item.username }}</p>
      <p class="top-ranking-score">
        {{ item.score }} <span style="font-size: 12px">pts</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "CardTopRanking",
  props: ["top3Visual"],
};
</script>
<style scoped>
.wrapper-top-ranking {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 10px;
}
.card-top-ranking {
  position: relative;
  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 22px;

  background: #ffffff;

  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06), 0 10px 24px rgba(0, 0, 0, 0.08);
}

.top-ranking {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid purple;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -8%;
  background: #730ba9;
  color: #fff;
  font-weight: 500;
}

.top-ranking-username {
  margin: 5px 0px;
  font-weight: 500;
}
.top-ranking-score {
  font-size: 22px;
  font-weight: 500;
}
</style>
